<template>
  <div
    id="diagram-div"
    @update-layout="diagramUpdated"
    @click-breaker="breakerClick"
    v-on="$listeners"
  ></div>
</template>

<script>
import drawGraph, { updateGraph } from "@acelerex/sld";

export default {
  name: "ProjectDiagram",
  components: {},
  mixins: [],
  props: {
    network: {
      type: Object,
      required: false,
      default: () => ({}),
      validator: (v) =>
        Object.keys(v).every((key) =>
          [
            "bus",
            "busLocation",
            "storages",
            "generators",
            "markets",
            "loads",
            "branch",
            "switches",
            "transformers",
            "inverters",
            "ev",
          ].includes(key)
        ),
    },
    options: {
      type: Object,
      required: false,
      default: () => ({
        showLabels: true,
      }),
    },
    allowDrag: { type: Boolean, required: false, default: true },
    showLabelsDrag: { type: Boolean, required: false, default: true },
  },
  data() {
    return {};
  },
  computed: {
    resourcesCount() {
      return Object.values(this.network).reduce(
        (acc, resourceGroup) => acc + resourceGroup.length,
        0
      );
    },
    infoValues() {
      return Object.values(this.network).flatMap((resourceGroup) =>
        resourceGroup
          .flatMap((resource) => resource.info)
          .filter((metric) => metric)
          .map((metric) => metric.value)
      );
    },
    breakerStatus() {
      return Object.values(this.network).flatMap((resourceGroup) =>
        resourceGroup.flatMap((resource) => resource.breaker)
      );
    },
    switchStatus() {
      return JSON.stringify(Object.values(this.network.switches).map((v) => v.state));
    },
  },
  watch: {
    resourcesCount() {
      drawGraph(this.network, {
        allowDrag: this.allowDrag,
      });
    },
    infoValues() {
      updateGraph(this.network, {
        allowDrag: this.allowDrag,
      });
    },
    breakerStatus() {
      updateGraph(this.network, {
        allowDrag: this.allowDrag,
      });
    },
    switchStatus() {
      updateGraph(this.network, { allowDrag: this.allowDrag });
    },
    options(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        updateGraph(this.network, {
          allowDrag: this.allowDrag,
          showLabels: this.options.showLabels,
        });
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (this.network.bus.length) {
      drawGraph(this.network, { allowDrag: this.allowDrag });
    }
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    diagramUpdated($e) {
      const networkCopy = this.network;
      const { nodesPositions } = $e.detail;
      if (!nodesPositions) return;
      nodesPositions.forEach((pos) => {
        const node = networkCopy.bus.find((bus) => bus.id === pos.busId);
        node.x = pos.x;
        node.y = pos.y;
      });
      this.$emit("update:network", networkCopy);
    },
    breakerClick($e) {
      this.$emit("update-breakers", $e.detail);
    },
  },
};
</script>

<style>
@import "../assets/styles/sld.css"; /* optional Notion-like styles */
</style>
